import React from 'react';

export default function FlagTwo() {
  return (
    <svg
      width='64'
      height='71'
      viewBox='0 0 64 71'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
    >
      <path
        d='M57 10L52.1095 3.57688C51.353 2.58326 50.1758 2 48.927 2H14C12.8954 2 12 2.89543 12 4V10H57Z'
        fill='#A1A1AA'
      />
      <path
        d='M57 10L52.1095 3.57688C51.353 2.58326 50.1758 2 48.927 2H14C12.8954 2 12 2.89543 12 4V10H57Z'
        fill='black'
        fill-opacity='0.5'
      />
      <g filter='url(#filter0_dd_8281_7488)'>
        <path
          d='M12 4C12 2.89543 12.8954 2 14 2H50C51.1046 2 52 2.89543 52 4V46.7639C52 48.2507 50.4354 49.2177 49.1056 48.5528L32.8944 40.4472C32.3314 40.1657 31.6686 40.1657 31.1056 40.4472L14.8944 48.5528C13.5646 49.2177 12 48.2507 12 46.7639V4Z'
          fill='url(#paint0_linear_8281_7488)'
        />
        <path
          d='M23.301 32L23.8876 28.4602L32.399 21.9574C33.042 21.4536 33.5922 20.9896 34.0495 20.5653C34.5136 20.1411 34.8848 19.7169 35.1632 19.2926C35.4416 18.8684 35.6206 18.4044 35.7001 17.9006C35.7929 17.3371 35.7498 16.8532 35.5708 16.4489C35.3919 16.0445 35.1068 15.7363 34.7157 15.5241C34.3246 15.3054 33.854 15.196 33.3038 15.196C32.7404 15.196 32.2233 15.312 31.7527 15.544C31.282 15.7694 30.8909 16.1009 30.5794 16.5384C30.2744 16.9692 30.0723 17.4896 29.9728 18.0994H25.2995C25.5315 16.714 26.0453 15.5175 26.8407 14.5099C27.6362 13.5024 28.6438 12.7268 29.8635 12.1832C31.0832 11.633 32.4454 11.358 33.9501 11.358C35.488 11.358 36.7839 11.6165 37.8379 12.1335C38.8985 12.6506 39.6641 13.3731 40.1348 14.3011C40.612 15.2225 40.7479 16.2931 40.5424 17.5128C40.4099 18.2884 40.1215 19.0573 39.6774 19.8196C39.2399 20.5753 38.5405 21.4171 37.5794 22.3452C36.6182 23.2666 35.2958 24.3703 33.612 25.6562L30.8081 27.9034L30.7782 28.0327H39.041L38.3748 32H23.301Z'
          fill='url(#paint1_linear_8281_7488)'
        />
      </g>
      <defs>
        <filter
          id='filter0_dd_8281_7488'
          x='0'
          y='0'
          width='64'
          height='72'
          filterUnits='userSpaceOnUse'
          color-interpolation-filters='sRGB'
        >
          <feFlood flood-opacity='0' result='BackgroundImageFix' />
          <feColorMatrix
            in='SourceAlpha'
            type='matrix'
            values='0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0'
            result='hardAlpha'
          />
          <feMorphology
            radius='3'
            operator='erode'
            in='SourceAlpha'
            result='effect1_dropShadow_8281_7488'
          />
          <feOffset dy='10' />
          <feGaussianBlur stdDeviation='7.5' />
          <feColorMatrix
            type='matrix'
            values='0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.1 0'
          />
          <feBlend
            mode='normal'
            in2='BackgroundImageFix'
            result='effect1_dropShadow_8281_7488'
          />
          <feColorMatrix
            in='SourceAlpha'
            type='matrix'
            values='0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0'
            result='hardAlpha'
          />
          <feMorphology
            radius='4'
            operator='erode'
            in='SourceAlpha'
            result='effect2_dropShadow_8281_7488'
          />
          <feOffset dy='4' />
          <feGaussianBlur stdDeviation='3' />
          <feColorMatrix
            type='matrix'
            values='0 0 0 0 0.0627451 0 0 0 0 0.0941176 0 0 0 0 0.156863 0 0 0 0.1 0'
          />
          <feBlend
            mode='normal'
            in2='effect1_dropShadow_8281_7488'
            result='effect2_dropShadow_8281_7488'
          />
          <feBlend
            mode='normal'
            in='SourceGraphic'
            in2='effect2_dropShadow_8281_7488'
            result='shape'
          />
        </filter>
        <linearGradient
          id='paint0_linear_8281_7488'
          x1='32'
          y1='2'
          x2='32'
          y2='50'
          gradientUnits='userSpaceOnUse'
        >
          <stop stop-color='#A1A1AA' />
          <stop offset='1' stop-color='#484848' />
        </linearGradient>
        <linearGradient
          id='paint1_linear_8281_7488'
          x1='32'
          y1='2'
          x2='32'
          y2='42'
          gradientUnits='userSpaceOnUse'
        >
          <stop stop-color='#151518' />
          <stop offset='1' stop-color='#484848' />
        </linearGradient>
      </defs>
    </svg>
  );
}
